import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[(false)?_c(VCardSubtitle,[_vm._v(_vm._s(_vm.Content.title))]):_vm._e(),_vm._l((_vm.Content.items),function(item,index){return _c(VBtn,{key:index,staticClass:"ma-2",attrs:{"small":"","color":"toolBar1"},on:{"click":item.action}},[_vm._v(_vm._s(item.label))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }